const params = new URLSearchParams(location.search);
const paramAll = {};
params.forEach((val, key) => {
  paramAll[key] = val;
});

// デフォルト値設定
if (!paramAll.paged) {
  paramAll.paged = 1;
  params.set('paged', 1);
}

export function getQueryParamAll () {
  return paramAll;
}

export function getQueryParam (key) {
  return params.get(key);
}
